import  { h, Component, RenderableProps } from 'preact';

//slash was &#xFF0F;
interface ProgressProps { done: number; total: number }


export function Progress( { done, total }: ProgressProps )  {
    return (
        <div class="progress">
            <span class="progress-done">{done}</span>
            <span class="progress-slash">&#xFF0F;</span>
            <span class="progress-total">{total}</span>
        </div>
    )
}

